var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center","height":"100%"}},[_vm._v("REPLACE PWA page")])}
var staticRenderFns = []

export { render, staticRenderFns }